// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__15omv","form":"styles_form__1k4u6"};